import { create } from "zustand";

interface UiStore {
  view: "mobile" | "desktop";
  showLog: boolean;
  toggleLog: () => void;
  setView: (v: "mobile" | "desktop") => void;
}

export const useUiStore = create<UiStore>((set) => ({
  view: "desktop",
  showLog: false,
  toggleLog: () => set((s) => ({ showLog: !s.showLog })),
  setView: (v) => set({ view: v }),
}));
